import { BaseText, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import { Lang } from 'types/generatedSchemaTypes';
import { logCustomEvent } from 'utils/analytics';
import { useUiStore } from 'stores/uiStore';

const Chip = styled.TouchableOpacity`
  background-color: ${theme.colors.white};
  padding: 8px 12px;
  border-radius: 40px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
`;

const LanguageButton = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language as Lang;

  const openLanguageModal = async () => {
    await logCustomEvent('language_selector_open', {
      currentLanguage: currentLanguage,
    });
    useUiStore.getState().setSheetModal('language');
  };

  return (
    <Chip onPress={openLanguageModal}>
      <Icon name={'Globe-Outlined'} />
      <BaseText>{currentLanguage.toUpperCase()}</BaseText>
      <Icon name={'Chevron_Down'} />
    </Chip>
  );
};

export default LanguageButton;
